import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/features/login/LoginPage';

const loginSearchSchema = z.object({
	return_to: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
	validateSearch: loginSearchSchema,
	component: RouteComponent,
});

function RouteComponent() {
	const { return_to } = Route.useSearch();
	return <LoginPage returnTo={return_to} />;
}
